<template>
  <div class="card">
    <header
      class="card-header"
      :class="{ 'has-background-dark has-text-info-light': interval }"
    >
      <div
        class="card-header-title py-0"
        :class="{ 'has-text-info-light': interval }"
      >
        <div class="is-size-3 mr-1">
          {{ table.name.substring(0, 2).toUpperCase() }}
        </div>
        <div class="is-size-7">
          <div>{{ table.type }}</div>
          <div>
            <span class="material-symbols-outlined">schedule</span>
            {{ open_time }}
          </div>
        </div>
      </div>
      <button class="card-header-icon" @click="showModal('bill-history')">
        <span class="material-symbols-outlined"> history</span>
      </button>
    </header>
    <div class="card-content p-0">
      <div class="level mb-2">
        <span
          class="level-item tag is-small has-background-grey has-text-white-ter table-visit-status"
          style="border-radius: 0 0 0.25rem 0.25rem"
        >
          {{ elapsed }}
        </span>
      </div>
      <p class="is-size-4 has-text-right mx-4">{{ currency(due) }}</p>
    </div>
    <footer class="card-footer" v-if="table.type == 'Mesa'">
      <a
        class="card-footer-item button is-info"
        v-if="interval"
        @click="showModal('check')"
      >
        <span class="material-symbols-outlined">point_of_sale</span>&nbsp;Pagar
      </a>
      <a class="card-footer-item button is-success" @click="showModal('add')">
        <span class="material-symbols-outlined">add</span>&nbsp;Agregar
      </a>
    </footer>
    <footer class="card-footer" v-else>
      <a
        class="card-footer-item button is-info"
        @click="showModal('quick-check')"
      >
        <span class="material-symbols-outlined">point_of_sale</span>&nbsp;Pago
        Rápido
      </a>
    </footer>
    <!-- Modal for adding -->
    <table-bucket-modal
      v-if="show_add_modal"
      :table="table"
      :due_history="due_history"
      :show-modal="show_add_modal"
      @add-due="addDue"
      @close-modal="closeModal('add')"
      @delete-due="deleteDue"
    ></table-bucket-modal>
    <!-- Modal for check -->
    <table-bucket-check
      v-if="show_check_modal"
      :table="table"
      :due_history="due_history"
      :show-modal="show_check_modal"
      @check-done="checkBill"
      @close-modal="closeModal('check')"
    ></table-bucket-check>
    <!-- Modal for quick check -->
    <table-bucket-quick-check
      v-if="show_quick_check_modal"
      :table="table"
      :show-modal="show_quick_check_modal"
      @check-done="quickCheckBill"
      @close-modal="closeModal('quick-check')"
    ></table-bucket-quick-check>
    <!-- Modal for history -->
    <table-bucket-bill-history
      v-if="show_bill_history_modal"
      :table="table"
      :show-modal="show_bill_history_modal"
      @close-modal="closeModal('bill-history')"
    ></table-bucket-bill-history>
  </div>
</template>

<script>
import TableBucketModal from "@/components/TableBucketModal";
import TableBucketCheck from "@/components/TableBucketCheck";
import TableBucketQuickCheck from "@/components/TableBucketQuickCheck";
import TableBucketBillHistory from "@/components/TableBucketBillHistory";

import { formatDistance, differenceInMinutes, format } from "date-fns";
import { es } from "date-fns/locale";
import axios from "axios";
import * as bulmaToast from "bulma-toast";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "TableBucket",
  components: {
    TableBucketModal,
    TableBucketCheck,
    TableBucketQuickCheck,
    TableBucketBillHistory,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    table: {},
    update_interval: {
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      interval: null,
      elapsed: "Disponible",
      first_request: null,
      show_add_modal: false,
      show_check_modal: false,
      show_quick_check_modal: false,
      show_bill_history_modal: false,
      due: 0,
      due_history: [],
    };
  },
  computed: {
    open_time() {
      if (!this.first_request) {
        return null;
      }
      return format(this.first_request, "p");
    },
  },
  mounted() {
    if (this.table.last_status.length > 0) {
      this.due = this.table.last_status[0].due || 0;
      this.due_history = this.table.last_status[0].due_history || {};
      if (!this.interval) {
        this.first_request = this.table.last_status[0].due_history[0].timestamp;
        this.interval = setInterval(() => {
          this.updateTime();
        }, this.update_interval);
        this.updateTime();
      }
    }
  },
  methods: {
    showModal(modal) {
      switch (modal) {
        case "add":
          this.show_add_modal = true;
          break;
        case "check":
          this.show_check_modal = true;
          break;
        case "quick-check":
          this.show_quick_check_modal = true;
          break;
        case "bill-history":
          this.show_bill_history_modal = true;
          break;
      }
    },
    closeModal(modal) {
      switch (modal) {
        case "add":
          this.show_add_modal = false;
          break;
        case "check":
          this.show_check_modal = false;
          break;
        case "quick-check":
          this.show_quick_check_modal = false;
          break;
        case "bill-history":
          this.show_bill_history_modal = false;
          break;
      }
    },
    addDue(due) {
      if (!this.interval) {
        this.first_request = Date.now();
        this.interval = setInterval(() => {
          this.updateTime();
        }, this.update_interval);
        this.updateTime();
      }
      // console.log(this.interval);
      this.show_add_modal = false;
      this.due += due;
      this.due_history.push({
        timestamp: Number(Date.now()),
        due: due,
        is_deleted: false,
      });
      // Mantener estado en api

      let formData = {
        table: this.id,
        due: this.due,
        due_history: this.due_history,
      };
      this.updateTableStatus(formData);
    },
    deleteDue(due) {
      this.due -= due.due;
      this.due_history[this.due_history.indexOf(due)].is_deleted = true;
      let formData = {
        table: this.id,
        due: this.due,
        due_history: this.due_history,
      };
      this.updateTableStatus(formData);
    },
    async updateTableStatus(data) {
      await axios
        .post(
          `/api/v1/shop${this.table.get_absolute_url}temporary-status/`,
          data
        )
        .then((response) => {
          //TODO: notificaciones
          console.log(response.data);
          bulmaToast.toast({
            message: `Mesa ${this.table.name} actualizada!`,
            type: "is-success",
            position: "bottom-right",
          });
          this.$emit("takenTable");
        })
        .catch((error) => {
          //TODO: notificaciones
          console.log(error);
          bulmaToast.toast({
            message: `La mesa ${this.table.name} no pudo ser actualizada!`,
            type: "is-warning",
            position: "bottom-right",
          });
        });
    },
    async registerBill(data, last_request) {
      await axios
        .post(`/api/v1/shop${this.table.get_absolute_url}checkout`, data)
        .then((response) => {
          this.$emit("checkBill", {
            due: this.due,
            visit_time_minutes: differenceInMinutes(
              this.first_request,
              last_request
            ),
            history: this.due_history,
            bill_id: response.data["uuid"],
          });
          console.log("request: " + data.uuid);
          console.log("response: " + response.data["uuid"]);
          bulmaToast.toast({
            message: `Mesa ${this.table.name} cerrada!`,
            type: "is-success",
            position: "bottom-right",
          });
          this.due = 0;
          this.due_history = [];
          if (this.interval) {
            clearInterval(this.interval);
          }
          this.interval = null;
          this.first_request = null;
          this.elapsed = "Disponible";
          return true;
        })
        .catch((error) => {
          console.log(error);
          bulmaToast.toast({
            message: `La mesa ${this.table.name} no pudo cerrada!`,
            type: "is-warning",
            position: "bottom-right",
          });
          return false;
        });
    },
    async checkBill() {
      // console.log("checkBill");
      this.show_check_modal = false;
      // Calculates visit Time and emit event to check
      let last_request = new Date();
      let data = {
        uuid: uuidv4(),
        created_at: last_request.toISOString(),
        table: this.id,
        total: this.due,
        items: this.due_history,
      };
      this.registerBill(data, last_request);
    },
    async quickCheckBill(cash) {
      console.log("quickCheckBill");
      this.show_quick_check_modal = false;
      this.due = cash;
      // Calculates visit Time and emit event to check
      let last_request = new Date();
      this.first_request = last_request;
      this.due_history.push({
        due: this.due,
        timestamp: Number(last_request),
        is_deleted: false,
      });

      let data = {
        uuid: uuidv4(),
        created_at: last_request.toISOString(),
        table: this.id,
        total: this.due,
        items: this.due_history,
      };

      this.registerBill(data, last_request);
    },
    currency(val) {
      let cur = Intl.NumberFormat("es-CO");
      return `$ ${cur.format(val)}`;
    },
    updateTime() {
      this.elapsed = formatDistance(this.first_request, Date.now(), {
        includeSeconds: true,
        locale: es,
      });
    },
  },
};
</script>

<style scoped></style>
